<template>
  <div class="Copyright">
    <p>{{pageOption.copyright}}</p>
  </div>
</template>

<script>
// @ is an alias to /src
import { pageOption } from "@/api/login/login.js";

export default {
  name: "Copyright",
  data() {
    return {
      pageOption: {
        copyright: ''
      }
    }
  },
  mounted() {
    pageOption().then(res => {
      if (res.code == 200) {
        this.pageOption = res.data
      }
    })
  }
};
</script>
<style>
.Copyright {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #fff;
  line-height: 4;
}
</style>
